/**
 * Capitalize the first character of a string
 * @param {string} str
 * @returns {string}
 */
export function capitalize(str: string): string {
  if (!str) return str;
  return str[0].toUpperCase() + str.slice(1);
}